import * as React from 'react';
import Icon from '../Icon';


var ChevronLeftIcon = function (_a) {
    var onClick = _a.onClick, disabled = _a.disabled;
    return (React.createElement(Icon, { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", className: "ChevronLeftIcon " + (disabled ? 'disabled' : ''), onClick: onClick },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.1717 12.7187C11.387 12.9204 11.387 13.2471 11.1717 13.4488C10.9562 13.6504 10.607 13.6504 10.3917 13.4488L4.96139 8.36506C4.74594 8.16351 4.74594 7.83659 4.96139 7.63489L10.3917 2.55126C10.607 2.34957 10.9562 2.34957 11.1717 2.55126C11.387 2.75281 11.387 3.07974 11.1717 3.28143L6.13117 7.99998L11.1717 12.7187Z", fill: "#121212" })));
};
export default React.memo(ChevronLeftIcon);
